<template>
    <div class="index">
        <div class="box" v-if="isReload==false && custom_product_data.length!==0">
            <!-- 轮播图 -->
            <el-carousel trigger="click" height="473px" class="swiper">
                <el-carousel-item v-for="item in baner_list" :key="item.access_banner_url">
                    <el-image
                        fit="cover"
                        style="width:100%;height:473px"
                        :src="item.access_banner_url"
                    >
                        <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">
                            <div class="el_image">
                                <span class="dot" v-loading="true"  element-loading-spinner="el-icon-loading" style="font-size:26px"></span>
                            </div>
                        </div>
                        <div slot="error" class="image-slot"  style="width:100%;height:100%;">
                            <div class="el_image">
                                <el-image  fit="cover" :src="src.src_err"  style="width:200px;height:200px;"></el-image>
                            </div>
                        </div>
                    </el-image>
                </el-carousel-item>
            </el-carousel>
            <!-- 导航 -->
            <div class="nav_box">
                <div>
                    <ul class="nav_ul" ref="nav_ul">
                        <li v-for="item in custom_product_data" :key='item.product_top_class_id+"nav"'>
                            <span>{{item.product_class_name}}</span>
                            <i class="iconfont icon-youkuohao" style="font-size:14px;"></i>
                            <div class="product_box" ref="product_box">
                                <div>
                                    <span>{{item.product_class_name}}</span>
                                    <router-link tag="div" :to="{path:'/product_list',query:{product_class_name:item.product_class_name,product_top_class_id:item.product_top_class_id}}" class="look_more">查看更多<i class="iconfont icon-youkuohao"></i></router-link>
                                </div>
                                <ul>
                                    <router-link tag="li" :to="{path:'/product_detail',query:{proproduct_class_name:item.product_class_name,product_name:item.product_name,product_hash:item.product_hash}}" v-for="item in item.product_list.slice(0, 8)" :key="item.product_hash+'nav'" >
                                        <el-image
                                            fit="cover"
                                            style="width:70px;min-width:70px;height:70px;"
                                            :src="item.product_img_url+'!small'"
                                        >
                                            <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">
                                                <div class="el_image">
                                                    <span class="dot" v-loading="true"  element-loading-spinner="el-icon-loading" style="font-size:14px"></span>
                                                </div>
                                            </div>
                                            <div slot="error" class="image-slot"  style="width:100%;height:100%;">
                                                <div class="el_image">
                                                    <el-image  fit="cover" :src="src.src_err"  style="width:70px;height:70px;"></el-image>
                                                </div>
                                            </div>
                                        </el-image>
                                        <span>{{item.product_name}}</span>
                                    </router-link>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 产品系列 d3dce6 99a9bf-->
                <div class="product_series" v-for="item in custom_product_data" :key="item.product_top_class_id">
                    <div>
                        <h3>{{item.product_class_name}}</h3>
                        <router-link tag="div" :to="{path:'/product_list',query:{product_class_name:item.product_class_name,product_top_class_id:item.product_top_class_id}}">更多&nbsp;<i class="iconfont icon-youkuohao" style="font-size:14px;">&#xe684;</i></router-link>
                    </div>
                    <ul>
                        <router-link tag="li" :to="{path:'/product_detail',query:{proproduct_class_name:item.product_class_name,product_name:item.product_name,product_hash:item.product_hash}}" v-for="item in item.product_list.slice(0, 4)" :key="item.product_hash">
                            <el-image
                                    lazy
                                    fit="cover"
                                    style="width:292px;min-width:292px;height:292px;"
                                    :src="item.product_img_url + '!small'"
                            >
                                <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">
                                    <div class="el_image">
                                        <span class="dot" v-loading="true"  element-loading-spinner="el-icon-loading" style="font-size:20px"></span>
                                    </div>
                                </div>
                                <div slot="error" class="image-slot"  style="width:100%;height:100%;">
                                    <div class="el_image">
                                        <el-image  fit="cover" :src="src.src_err"  style="width:70px;height:70px;"></el-image>
                                    </div>
                                </div>
                            </el-image>
                            <span :title="item.product_name">{{item.product_name}}</span>
                            <p>
                                <span>￥{{item.product_discount_price}}</span>
                                <span>￥{{item.unit_price}}</span>
                            </p>
                        </router-link>
                    </ul>
                </div>
                <!-- 底部banner -->
                <!--            <div  class="abanner"><div style="color: black;">湿腾商学院</div></div>-->
                <div target="view_window" class="banner">
                    <div style="width: 100%;height: 120px">
                        <div style="width: 30%" class="yl">
                            <div style="margin-top: 20px;">链接</div>

                            <div @click="pushScheme" style="padding-top: 10px;text-align: center;line-height: 25px; display: flex;flex-direction: row;">
                                <el-image :src="src.src_sxy" style="height: 20px;width: 20px; "></el-image>
                                <div style="padding-left: 8px;">湿腾商学院</div>
                            </div>
                        </div>

                    </div>
<!--                    <a href="http://www.yuximi.com/web/index.html#/home"  >-->
<!--                        <el-image-->
<!--                                fit="cover"-->
<!--                                style="width:100%;height:120px;display:block;"-->
<!--                                :src="src.src_banner"-->
<!--                        >-->
<!--                            <div slot="error" class="image-slot"  style="width:100%;height:100%;">-->
<!--                                <div class="el_image">-->
<!--                                    <el-image  fit="cover" :src="src.src_err"  style="width:100px;height:100px;"></el-image>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </el-image>-->
<!--                    </a>-->
                </div>
        </div>
        <!-- 数据加载 -->
        <div v-if="isReload"  style="width:1200px;height:600px;background:transparent;margin:0 auto;" class="el_image">
            <div v-loading="true"></div>
            <div style="color:#409eff;font-size:14px;margin:100px 0 0 -14px;">数据加载中</div>
        </div>
        <!-- 无数据 -->
        <div  v-if="isReload==false && custom_product_data.length==0" style="width:1200px;height:600px;background:transparent;margin:0 auto;" class="el_image">
            <el-image
                fit="cover"
                style="width:600px;height:600px;"
                :src="src.src_null"
            >
                <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">
                    <div class="el_image">
                        <span class="dot" v-loading="true"  element-loading-spinner="el-icon-loading" style="font-size:20px"></span>
                    </div>
                </div>
                <div slot="error" class="image-slot"  style="width:100%;height:100%;">
                    <div class="el_image">
                        <el-image  fit="cover" :src="src.src_err"  style="width:100px;height:100px;"></el-image>
                    </div>
                </div>
            </el-image>
        </div>
    </div>
</template>
<script>
import src_err from '@/assets/img/err.png'
import src_null from '@/assets/img/null.png'
import src_banner from '@/assets/img/banner.jpg'
import src_sxy from '@/assets/img/sxy.png'
export default {
    name:'index',
    data(){
        return {
            src:{
                src_err,
                src_null,
                src_banner,
              src_sxy
            },
            // 轮播图
            baner_list:[],
            // 客户产品数据
            custom_product_data:[],
            // 是否加载
            isReload:true
        }
    },
    methods:{
      pushScheme() {
        var url = 'http://course.stdq.com'
        window.open(url, '_blank');
      },
        // 获取页面数据的ajax
        getPageAjax(){
            this.$http({
                url: 'index',
                data: {}
            }).then(res=>{
                this.isReload=false
                if(res.code==1){
                    this.baner_list=res.data.banner_list
                    this.custom_product_data=res.data.custom_product_data
                }
            }).catch(err => {
                console.log(err);
            });
        },
        // 获取购物车商品数量
        getGoodsCound(){
            this.$http({
                url: 'goods_count',
                data: {}
            }).then((res)=>{
                if(res.code==1){
                    this.$store.commit({
                        type:'set_goodsCount',
                        num:res.data.cart_product_count
                    })
                }
            }).catch((err)=>{
                console.log(err)
            })
        },
    },
    created(){
        this.getPageAjax()
        this.getGoodsCound()
    },
}
</script>
<style  scoped lang='scss'>
    .yl{
        display: flex;
        flex-direction: column;
        justify-items: center;
        align-items: center;
    }
.index{
    position:relative;
    left:0;
    top:0;
    background:#F7F7F5;
    .box{
        width:1200px;
        margin:0 auto;
    };
    box-sizing:border-box;
    padding-top:46px;
}
.swiper{
    width:100%;
    height:473px;
    position:absolute;
    left:0;
    top:46px;
    z-index:0;
}
/* 导航 */
.nav_box{
    width:831px;
    height:473px;
    z-index:1;
    display:flex;
    align-items: center;
    position:relative;
    left:0;
    top:0;
    >div{
        height:460px;
        padding:15px 0;
        background-color: rgba(255, 255, 255, .9);
    }
    .hide_scroll_bar{
        width:17px;
        height:460px;
        position:absolute;
        top:7px;
        right:605px;
        background-color: rgba(255, 255, 255, 1);
    }
}
.nav_ul{
    /*width:226px;*/
    width:280px;
    height:433px;
    overflow-x:visible!important;
    overflow-y:scroll;
    scrollbar-width: none;
    /*隐藏滚动条，当IE下溢出，仍然可以滚动*/
    -ms-overflow-style:none;
}
/* 修改滚动条样式 */
.nav_ul::-webkit-scrollbar {/*滚动条整体样式*/
    width: 0px;         /*高宽分别对应横竖滚动条的尺寸*/
    height: 0px;
}

.nav_ul>li{
    height:40px;
    padding:0 20px;
    display:flex;
    align-items: center;
    justify-content: space-between;
}
.nav_ul>li:hover{
    background:#409eff!important;
    cursor:pointer!important;
    >span,>i{
        color:white!important;
    }
}
.nav_ul>li:hover .product_box{
    display:block!important;
}
.product_box{
    width:605px;
    height:460px;
    background:rgba(246, 251, 254, 1);
    padding:20px 0;
    display:none;
    position:absolute;
    left:280px;
    top:7px;
    >div{
        display:flex;
        align-items:center;
        justify-content: space-between;
        font-size:14px;
        margin:0 47px 13px;
        .look_more{
            display:flex;
            align-items:center;
            color:#AAAAAA;
        }
        .look_more:hover{
            color:#409eff;
            cursor:pointer;
        }
    }
}
.product_box>ul{
    display:flex;
    flex-wrap:wrap;
}
.product_box>ul>li{
    box-sizing: border-box;
    width:230px;
    height:84px;
    padding:0 10px;
    border:1px solid #DDDDDD;
    display:flex;
    align-items: center;
    cursor:pointer;
}
.product_box>ul>li:nth-child(2n+1){
    margin:5px 24px 5px 48px;

}
.product_box>ul>li:nth-child(2n){
    margin:5px 48px 5px 25px;
}
.product_box>ul>li>div{
    background:#d3dce6;
    margin-right:10px;
}
.product_box>ul>li>span{
    overflow: hidden;
    text-overflow:ellipsis;
    display: -webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient: vertical;
}

/* 产品系列 */
.product_series{
    padding-top:20px;
    background:#F7F7F5;
}
.product_series:last-of-type{
    padding-bottom:180px;
}
.product_series>div,.product_series>ul{
    width:1200px;
}
.product_series>div{
    height:86px;
    display:flex;
    align-items: center;
    justify-content: space-between;
    font-size:20px;
}
.product_series>div>div:hover{
    color:#409eff;
    cursor:pointer;
}
.product_series>div{
    >h3{
        font-size:30px;
        font-weight:500;
    }
    >div{
        font-size:16px;
    }
}
.product_series>ul{
    display:flex;
    align-items: center;
}
.product_series>ul>li{
    cursor:pointer;
    width:292px;
    height:392px;
    background:white;
    margin-right:10px;
}
.product_series>ul>li:hover{
    box-shadow:0 10px 30px #DDDD;
    transform: scale(1.05);
    transition:all .3s;
}
.product_series>ul>li:last-child{
    margin-right:0;
}
.product_series>div:last-child{
    margin-bottom: 120px;
}
.product_series>ul>li>p,.product_series>ul>li>span{
    text-align: center;
    display:block;
}
.product_series>ul>li>span{
    height:23px;
    line-height:23px;
    margin:16PX 20px;
    text-overflow:ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.product_series>ul>li>p>span:first-child{
    color:#E51C23;
    font-size:20px;
    margin:0 10px;
}
.product_series>ul>li>p>span:last-child{
    text-decoration: line-through;
    color:#BABCBE;
    font-size:14px;
    margin:0 10px;
}
.banner{
    // display:block;
    width:100%;
    height:120px;
    position:absolute;
    left:0;
    bottom:-120;
    img{
        display:block;
    }
}

</style>
<style scoped>
.swiper >>> .el-carousel__button{
    width:15px;
    height:15px;
    border-radius:50%;
}
.swiper >>> .el-carousel__indicators--horizontal{
    left:80%;
    z-index:10!important;
}
.swiper >>> .el-carousel__arrow--left,.swiper >>> .el-carousel__arrow--right{
    display:none;
}
.swiper >>> .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}
.swiper >>> .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}
</style>
